import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook } from "lucide-react";
import { useData } from "../context/DataContext";
import { resolveImageUrl } from "../admin/ImageUpload";
import { openCookieSettings } from "./CookieBanner";

const Footer = () => {
  const { settings } = useData();
  const SITE = settings || {};
  const logo = resolveImageUrl(SITE.logo);
  return (
    <footer className="bg-blush-light/60 border-t border-blush mt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          {logo ? (
            <img src={logo} alt="L'Élan Danse" className="h-20 w-auto object-contain" />
          ) : (
            <div className="flex flex-col leading-none">
              <span className="font-script text-4xl text-deep-rose">L&apos;élan</span>
              <span className="font-script text-3xl text-deep-rose -mt-2 self-start ml-12">Danse</span>
            </div>
          )}
          <p className="text-stone-600 mt-4 text-sm leading-relaxed font-serif-display">
            École de danse classique et moderne située au Perray-en-Yvelines. Cours pour enfants, adolescents et adultes — dans la joie, la rigueur et la passion du mouvement.
          </p>
        </div>

        <div>
          <h4 className="font-serif-display text-lg uppercase tracking-widest text-deep-rose mb-4">Navigation</h4>
          <ul className="space-y-2 text-stone-600">
            <li><Link to="/" className="hover:text-deep-rose transition-colors">Accueil</Link></li>
            <li><Link to="/cours-tenues" className="hover:text-deep-rose transition-colors">Cours &amp; Tenues</Link></li>
            <li><Link to="/planning-tarifs" className="hover:text-deep-rose transition-colors">Planning &amp; Tarifs</Link></li>
            <li><Link to="/inscription" className="hover:text-deep-rose transition-colors">Inscription</Link></li>
            <li><Link to="/galerie" className="hover:text-deep-rose transition-colors">Galerie Photos</Link></li>
            <li><Link to="/contact" className="hover:text-deep-rose transition-colors">Contact</Link></li>
            <li><Link to="/espace-famille/login" data-testid="footer-parent-login-link" className="hover:text-deep-rose transition-colors">Espace famille</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif-display text-lg uppercase tracking-widest text-deep-rose mb-4">Nous trouver</h4>
          <ul className="space-y-3 text-stone-600">
            <li className="flex gap-3"><MapPin size={18} className="shrink-0 mt-1 text-deep-rose" /><span>{SITE.address}</span></li>
            <li className="flex gap-3 items-center"><Phone size={18} className="text-deep-rose" /><a href={`tel:${SITE.phone}`}>{SITE.phone}</a></li>
            <li className="flex gap-3 items-center"><Mail size={18} className="text-deep-rose" /><a href={`mailto:${SITE.email}`}>{SITE.email}</a></li>
          </ul>
          <div className="flex gap-3 mt-5">
            <a href="#" aria-label="Instagram" className="p-2 rounded-full bg-white hover:bg-blush transition-colors text-deep-rose"><Instagram size={18} /></a>
            <a href="#" aria-label="Facebook" className="p-2 rounded-full bg-white hover:bg-blush transition-colors text-deep-rose"><Facebook size={18} /></a>
          </div>
        </div>
      </div>
      <div className="border-t border-blush py-6 px-6">
        <ul className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-stone-500 font-serif-display tracking-wide">
          <li><Link to="/mentions-legales" data-testid="footer-legal-mentions" className="hover:text-deep-rose transition-colors">Mentions légales</Link></li>
          <li><Link to="/politique-de-confidentialite" data-testid="footer-legal-privacy" className="hover:text-deep-rose transition-colors">Politique de confidentialité</Link></li>
          <li><Link to="/conditions-generales-utilisation" data-testid="footer-legal-cgu" className="hover:text-deep-rose transition-colors">CGU</Link></li>
          <li><a href={SITE.legalCgvUrl || "/legal/cgv.pdf"} target="_blank" rel="noopener noreferrer" data-testid="footer-legal-cgv" className="hover:text-deep-rose transition-colors">CGV</a></li>
          <li><a href={SITE.legalReglementUrl || "/legal/reglement-interieur.pdf"} target="_blank" rel="noopener noreferrer" data-testid="footer-legal-reglement" className="hover:text-deep-rose transition-colors">Règlement intérieur</a></li>
          <li><Link to="/cookies" data-testid="footer-legal-cookies" className="hover:text-deep-rose transition-colors">Cookies</Link></li>
          <li><button type="button" onClick={openCookieSettings} data-testid="footer-cookie-settings" className="hover:text-deep-rose transition-colors underline">Gérer les cookies</button></li>
        </ul>
      </div>
      <div className="border-t border-blush text-center py-4 text-stone-500 text-xs font-serif-display tracking-wide">
        © {new Date().getFullYear()} {SITE.name || "L'Élan Danse"} — Tous droits réservés. <span className="mx-2">·</span> <Link to="/admin/login" className="hover:text-deep-rose">Espace admin</Link>
      </div>
    </footer>
  );
};

export default Footer;
